import { useState } from "react";

import FormInput from '../form-input/form-input.component';

import Button, { BUTTON_TYPE_CLASSES } from '../button/button.component';

import { 
    signInWithGooglePopup, 
    signInAuthUserWithEmailAndPassword
} from '../../utils/firebase/firebase.utils';

import { 
    SigInContainer, 
    ButtonsContainer, 
} from './sign-in-form.styles';

const defaultFormFields = {
    email: '',
    password: '',
};

const SignInForm = () => {
    const [formFields, setFormFields] = useState(defaultFormFields);
    const { email, password } = formFields;

    
    const resetFormFields = () => {
        setFormFields(defaultFormFields);
    };

    const signInWithGoogle = async () => {
     await signInWithGooglePopup();
        

    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        try {
        await signInAuthUserWithEmailAndPassword(
        email, 
        password
        );
        resetFormFields();
        } catch (error) {
            switch (error.code) {
                case 'auth/wrong-password':
                alert('incorrect password for email');
                break;
                case 'auth/user-not-found':
                alert('incorrect password for email');
                break;
                default:
                console.log(error)
            }
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFormFields({ ...formFields, [name]: value });
    };
    return (
        <SigInContainer>
        <h2>Already have an account?</h2>
        <span>Sign in with your email & password!</span>
        <form onSubmit={handleSubmit}>

        <FormInput 
        label="Email"
        type="email" 
        required 
        onChange={handleChange} 
        name="email" 
        value={email}
        />

        <FormInput 
        label="Password"
        type="password" 
        required 
        onChange={handleChange} 
        name="password" 
        value={password}    
        />

        <ButtonsContainer>
        <Button type='submit'>Sign In</Button>
        <Button 
            buttonType={BUTTON_TYPE_CLASSES.google} 
            type='button' 
            onClick={signInWithGoogle}>Google Sign In
        </Button>
        </ButtonsContainer>
        </form>
        </SigInContainer>
    );
};

export default SignInForm;